import script from "./kmoocDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./kmoocDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./kmoocDetailPage.vue?vue&type=style&index=0&id=89cc0dc6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89cc0dc6"]])

export default __exports__